var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicationThumbUpOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.65 3.65V3.3c0-.183-.037-.375-.112-.575a1.588 1.588 0 00-.143-.292 1.066 1.066 0 00-.145-.183L15 1 8 8v13h10c.383 0 .75-.117 1.1-.35.35-.233.6-.517.75-.85l3-7.05A2.017 2.017 0 0023 12v-2c0-.533-.2-1-.6-1.4-.4-.4-.867-.6-1.4-.6h-5.45l1.1-4.35zm1.388 15.3l2.96-6.957.002-.008v-1.956a.555.555 0 00-.029-.029h-7.99l1.406-5.558L10 8.828V19h7.968a.514.514 0 00.07-.05zM6 8H2v13h4V8z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationThumbUpOutline);
export default __webpack_public_path__ + "531bc89214df5feb3e9ccbb4add5bc50.svg";
export { ForwardRef as ReactComponent };